































































import Vue from "vue";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import { DeliveryMode } from "../models/DeliveryMode";
export default Vue.extend({
  mixins: [pagination],
  data() {
    const isLoading = false;
    const searchText = "";
    const deliveryModes: DeliveryMode[] = [];
    return { isLoading, searchText, deliveryModes };
  },
  async created() {
    this.isLoading = true;
    (this as any).getPaginationRouteQuery();
    if ((this as any).search) {
      this.searchText = (this as any).search;
    }
    await this.getDeliveryModes();
    this.isLoading = false;
  },
  watch: {
    async "$route.query"() {
      await this.getDeliveryModes();
    }
  },
  methods: {
    async getDeliveryModes() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage,
        search: this.searchText
      };
      try {
        const {
          data,
          meta
        } = await (this as any).$dep.deliveryModeUseCase.getDeliveryModes(form);
        this.deliveryModes = data;
        (this as any).setPaginationMeta(meta);
        (this as any).setSearchQuery(this.searchText);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToShopSetAttributePage(id: any) {
      this.$router.push({
        name: "DeliveryShopSetAttributePage",
        params: { id }
      });
    }
  }
});
